import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import UserManagement from '../userManagement/container';
import { updateUMProps } from '../../../stores/settings/userManagement/actions';
import { RaisedButton, FontIcon, Divider } from 'material-ui';
import R from 'ramda';

const isNilOrEmpty = R.either(R.isEmpty, R.isNil);

const ManageUsers = (props) => {
  const { updateProp, companyType, corporateAccess, isSingleLoc, locAccess } = props;

  const canUserAddNewUser = () => {
    if (companyType === 'Supplier') {
      const locsUserCanEdit = isSingleLoc ? R.contains('write', R.pathOr([], [0, 'admin'], locAccess)) : R.contains('write', corporateAccess);
      return !isNilOrEmpty(locsUserCanEdit);
    }
    return R.contains('write', corporateAccess);
  };

  return (
    <div>
      <div className="flex-tc-sb" style={{ paddingBottom: '12px' }}>
        <div style={{ fontSize: '24px', fontWeight: 400 }}>Manage Users</div>
        <RaisedButton
          label="Add New User"
          icon={<FontIcon className="tc-icon-add" style={{ fontSize: '16px', marginTop: '-3px' }}/>}
          onTouchTap={() => {
            if (canUserAddNewUser()) {
              updateProp({ addingNewUserDialog: true });
            } else {
              updateProp({ noAccessDialog: true, requestingAccessToFeature: 'User Management', requestAccessData: { type: 'profileAccess' } });
            }
          }}
          secondary
        />
      </div>
      <Divider/>
      <UserManagement />
    </div>
  );
};

ManageUsers.propTypes = {
  updateProp: PropTypes.func,
  companyType: PropTypes.string,
  isSingleLoc: PropTypes.bool,
  corporateAccess: PropTypes.array,
  locAccess: PropTypes.array,
};

const mapDispatchToProps = dispatch => ({
  updateProp: (...args) => dispatch(updateUMProps(...args)),
});

const mapStateToProps = ({ user }) => ({
  companyType: user.getIn(['user', 'type']),
  isSingleLoc: user.getIn(['company', 'oneOrMultiProperties']) === 'one-prop',
  corporateAccess: user.get('corporateAccess'),
  locAccess: user.get('locAccess'),
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageUsers);



// WEBPACK FOOTER //
// ./src/app/components/settings/companySettings/manageUsers.jsx